module.exports = __webpack_public_path__ + "img/zhang.b8f59930.png";